import { createFileRoute } from "@tanstack/react-router";
import ArticleDetailWrapper from "@/components/ArticleDetailWrapper";
import { articleRouteHead } from "@/lib/articleRouteHead";
import { loadArticleSeo } from "@/lib/routeSeo";

// Dynamic article route — root-level slug (matched after all static routes)
export const Route = createFileRoute("/$slug")({
  loader: ({ params }) => loadArticleSeo(params.slug),
  head: ({ params, loaderData }) => articleRouteHead(params.slug, loaderData),
  component: ArticleDetailWrapper,
});
